import React from 'react';
import PropTypes from "prop-types";
import { Button, Paper, Toolbar, Tooltip } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import ExcelIcon from '../../../assets/excelIcon.png'
import PrintIcon from '@material-ui/icons/Print';

export const TableToolbarExportAndPrint = (props) => {
    const { cargada, handlePrint, handleGeneratePdf, handleExportExcel } = props;

    return (
      <Toolbar
        style={{placeContent: 'center'}}
      >
        {cargada&&
            <>
                <Paper>
                    {handlePrint&&
                        <Tooltip title="Imprimir">
                            <Button
                                onClick={handlePrint}
                            >
                                <PrintIcon fontSize="large"/>
                            </Button>
                        </Tooltip>
                    }
                    {handleGeneratePdf&&
                        <Tooltip title="Exportar Pdf">
                            <Button
                                onClick={() => handleGeneratePdf()}
                            >
                                <PictureAsPdfIcon fontSize="large"/>
                            </Button>
                        </Tooltip>
                    }
                    {handleExportExcel&&
                        <Tooltip title="Exportar Excel">
                            <Button
                                style={{marginRight: 15}}
                                onClick={() => handleExportExcel()}
                            >
                                <img src={ExcelIcon} alt='excelIcon' style={{height: 33}}></img>
                            </Button>
                        </Tooltip>
                    }                                        
                </Paper>
            </>
        }
      </Toolbar>
    );
  };
  
  TableToolbarExportAndPrint.propTypes = {
    cargada: PropTypes.bool.isRequired,
  };